import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { getSelectedStep } from '../store/slices/domainOrchestratorPricingCommittee.slice';
import { useCurrentOrchestrator } from './useCurrentOrchestrator';
import { IWorkflowStep } from '../interfaces/interfaces';

export const useSelectedWorkflowStep = () => {
  const selectedName = useSelector(getSelectedStep);
  const { currentOrchestrator } = useCurrentOrchestrator();
  const { data } = currentOrchestrator;

  const step: IWorkflowStep | undefined = useMemo(() => {
    if (!selectedName || !data?.workflow_steps) return undefined;
    return data.workflow_steps.find(ws => ws.name === selectedName);
  }, [data?.workflow_steps, selectedName]);

  return { step };
};
